<template>
  <div class="module-product-box">
    <div class="name-module flex" @click="showLesson = !showLesson">
      <div class="text-skin-gray">{{ item.name }}</div>
      <div class="action-arrow">
        <img
          class="cursor-pointer"
          src="../assets/icon_expandir_modulo.svg"
          alt=""
          srcset=""
          :class="{ 'transform-scale': showLesson }"
        />
      </div>
    </div>
    <div class="list-lesson" v-if="showLesson">
      <div v-for="data in item.lessons" :key="data.id">
        <div class="item flex text-skin-gray">
          <img
            src="../assets/icono_candado_desbloqueado.svg"
            class="mr-3"
            alt=""
          />
          {{ data.name }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showLesson: false,
    };
  },
};
</script>

<style scoped>
.name-module {
  background: #eeeeee 0% 0% no-repeat padding-box;
  border-radius: 15px;
  opacity: 1;
  margin-top: 20px;
  height: 30px;
  padding-left: 20px;
  padding-right: 20px;
  line-height: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.item {
  padding-left: 40px;
  font: normal normal normal 13px Roboto;
}

.transform-scale {
  transform: scaleY(-1);
}
</style>